<template>
  <nav>
    <div class = 'top flex_between'>
      <img src = './logo.svg' alt = ''/>
      <span @click = 'showNavList'></span>
    </div>
    <div class = 'nav_con' v-if = 'navListFlag'>
      <template v-if = '!secondNavFlag'>
        <ul class = 'nav_list'>
          <li v-for = '(item, index) in navList' @click = 'goSecondNav(index)'>
            <router-link :to = '{path: item.path}'>
              <span :class = '{active: activeIndex == index}'>{{item["name_" + lang]}}</span>
              <img src = '//cdn.idsbuybuybuy.com/image_20190904154129_37743.png' v-if = '(index == 1 || index == navList.length - 1)' alt = ''/>
            </router-link>
          </li>
        </ul>     
        <div class = 'lang'>
          <span :class = 'lang != "EN" ? "active" : ""'  @click = 'changeLang'>中</span>
          <span>/</span>
          <span :class = 'lang == "EN" ? "active" : ""' @click = 'changeLang'>EN</span>
        </div>
      </template>
      <template  v-if = 'secondNavFlag'>
        <div class = 'back' @click = 'goBack'></div>
        <div class = 'title'>{{navList[curIndex]["name_" + lang]}}</div>
        <ul class = 'series_list'>
          <li v-for = '(item, index) in navList[curIndex].child' @click = 'routerChange(item)'>
            <span :class = '{active: item.address == curPath}'>{{item["title_" + lang]}}</span>
          </li>
        </ul>
      </template>

    </div>
  </nav>
</template>
<script>
export default {
  props: {
    activeIndex: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      navList: [],
      navListFlag: false,
      secondNavFlag: false,
      curIndex: null,//当前进入二级菜单的index
      curPath: ''
    }
  },
  computed: {
    lang () {
      return this.$store.getters.getStoreLang;
    },
  },
  created() {
    this.getNavList();
    let arr = this.$route.path.split('/');
    this.curPath = arr[arr.length - 1];
  },
  methods: {
    // 获取导航列表
    getNavList(){
      if(!this.navList.length){
        const url = "../../static/json/nav/nav.json";
        this.$.get(url).then((res) => {
          let item = res.data.splice(2,1)[0];
          res.data.unshift(item);
          this.navList = res.data;
        })
      }
    },
    // 显示导航
    showNavList(){
      this.navListFlag = !this.navListFlag;
      this.secondNavFlag = false;
    },
    // 跳转到二级导航
    goSecondNav(index){
      if(index == 1 || index == 4){
        this.curIndex = index;
        this.secondNavFlag = true
      }
    },
    // 切换语言
    changeLang(){
      let type = this.lang == 'EN' ? 'CN': 'EN'
      this.$store.dispatch('setStoreLang', type);
      window.localStorage.setItem('lang', type);
      this.navListFlag = false;
      this.secondNavFlag = false;
    },
    goBack(){
      this.secondNavFlag = false
    },
    // 通过二级路由进入页面
    routerChange(item){
      if(this.curIndex == 1){
        this.$router.push({
          path: '/series/' + item.address
        })
        this.curPath = item.address;
        this.navListFlag = false;
        this.secondNavFlag = false;
      }else{
        this.$router.push({
          path: item.path
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  nav{
    position:fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    right: 0;
    .top{
      height: 0.88rem;
      background: #000;
      padding: 0 0.3rem;
      align-items: center;
      img{
        height: 0.5rem;
      }
      span{
        display: block;
        width: 0.6rem;
        height: 0.3rem;
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
      }
    }
    .nav_con{
      position: fixed;
      top: 0.88rem;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      color: #000;
      padding: 2vh 0.4rem;
      ul{
        padding-top: 5vh;
        margin-left: 0.2rem;
        li{
          color: #999;
          &:first-child{
            margin-top: 0;
          }
        }
      }
      .nav_list{
        animation: enterShow 0.3s;
        li{
          height: 0.48rem;
          font-size: 0.4rem;
          letter-spacing: 0;
          color: #999;
          margin-top: 5vh;
          line-height: .48rem;
          img{
            width: 0.5rem;
            height: 0.2rem;
            display: inline-block;
            margin-left: 0.4rem;
            object-fit: cover;
          }
          .right{
            background: url('//cdn.idsbuybuybuy.com/image_20190904154129_37743.png') no-repeat center;
            background-size: cover;
            width: 0.5rem;
            height: 0.2rem;
            vertical-align: baseline;
            display: inline-block;
            margin-left: 0.4rem;
          }
          .active{
            border-bottom: 1px solid #000;
            color: #000;
          }
        }
      }
      .series_list{
        animation: enterShow 0.3s;
        li{
          height: 0.48rem;
          font-size: 0.32rem;
          letter-spacing: 0;
          line-height: 0.48rem;
          margin-top: 5.5vh;
          span.active{
            border-bottom: 1px solid #000;
            color: #000;
          }
        }        
      }
      .back{
        background: url('//cdn.idsbuybuybuy.com/image_20190904154129_37743.png') no-repeat center;
        background-size: cover;
        transform: rotate(180deg);
        width: 0.5rem;
        height: 0.4rem;
      }
      .title{
        color: #000;
        font-size: 0.6rem;
        margin-top: 4vh;
      }
      .lang{
        margin-top: 2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        color: #999;
        font-size: 0.4rem;
        padding-left: 0.2rem;
        span{
          &.active{
            color: #000;
          }
        }
      }
    }
  }
// 横屏
  // @media screen and (orientation: landscape){
  //  nav{

  //  } 
  // }
  @keyframes enterShow{
    0%{margin-left: 0;}
    50%{margin-left: 0.1rem;}
    100%{margin-left: 0.2rem;}
  }
</style>



// WEBPACK FOOTER //
// src/common/webapp_nav.vue